









































import { ButtonType } from '@getaccept/lib-ui';
import { testMobileNumber } from '@getaccept/lib-shared/src/helpers';
import PhoneNumberInput from '@getaccept/lib-shared/src/components/PhoneNumberInput.vue';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { PropType } from '@vue/composition-api';
import { onMounted, computed, ref, defineComponent } from '@vue/composition-api';
import { useTwilio } from '../composables/twilio.composable';

export default defineComponent({
  components: {
    PhoneNumberInput,
  },
  props: {
    recipient: { type: Object as PropType<SigningPageRecipient>, default: undefined },
    entity: { type: Object as PropType<Entity>, default: undefined },
  },
  setup(props, { emit }) {
    const { loading, callSid, error, cancelCall, callPhone } = useTwilio();

    const phoneInputError = ref('');
    const phoneNumber = ref('');

    const calling = computed(() => !!callSid.value);

    const callButtonDisabled = computed(
      () => !phoneNumber.value || !!phoneInputError.value || calling.value
    );

    const handlePhoneInput = (value: string) => {
      phoneNumber.value = value;
      if (!testMobileNumber(value)) {
        phoneInputError.value = 'enter-a-valid-phone-number';
      } else {
        phoneInputError.value = '';
      }
    };

    const handleClose = () => {
      emit('close');
    };

    const handleCancelCall = () => {
      cancelCall();
    };

    const handleCallPhone = () => {
      callPhone(phoneNumber.value);
    };

    onMounted(() => {
      phoneNumber.value = props.recipient?.mobile || '';
    });

    return {
      phoneInputError,
      phoneNumber,
      ButtonType,
      loading,
      callSid,
      error,
      calling,
      callButtonDisabled,
      handlePhoneInput,
      handleClose,
      handleCancelCall,
      handleCallPhone,
    };
  },
});
